<app-info-panel [isOpen]="isOpen" [title]="title" (closed)="closed.emit()">
  <!-- main section -->
  <app-info-panel-section [columns]="1">
    <app-info-panel-field label="Name" i18n-label [value]="panel?.name" />
    <app-info-panel-field label="Description" i18n-label [value]="panel?.description" />
  </app-info-panel-section>

  <app-info-panel-section [columns]="2">
    <app-info-panel-field label="Input Type" i18n-label [value]="panel?.inputType" />
    <app-info-panel-field label="Status" i18n-label [value]="panel?.status" />
  </app-info-panel-section>

  <!-- applications section -->
  <app-info-panel-expansion-section title="Applications" i18n-label [columns]="1">
    @if (panel?.applications?.length === 0) {
      <app-info-panel-field value="" />
    }
    @for (appName of this.appNames; track appName) {
      <app-info-panel-field value="{{ appName }}" />
    }
  </app-info-panel-expansion-section>

  <!-- details -->
  <app-info-panel-expansion-section title="Details" i18n-label [columns]="2">
    <app-info-panel-field label="User Name" i18n-label [value]="panel?.userName" />
    <app-info-panel-field label="Created On" i18n-label [value]="panel?.createdOn | utcDate" />
    <app-info-panel-list-field label="Groups" i18n-label [value]="this.groups" />
    <app-info-panel-field label="Org ID" i18n-label [value]="panel?.orgId" />
    <app-info-panel-field label="Run Application Name" i18n-label [value]="panel?.runApplicationName" />
  </app-info-panel-expansion-section>
</app-info-panel>
